import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get_branch_emp_task_assignment } from "../../services/projectApi";
import CustomModal from "../../components/UiComponent/Modal";
import EmpTaskAssignmentForm from "./EmpTaskAssignmentForm";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../components/UiComponent/customTable";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
const TaskAssignment = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const getempTaskAssignmentQuery = useQuery(
    ["getbranchempTaskAssignment"],
    () => get_branch_emp_task_assignment(user?.employee?.branch_id)
  );
  const assignmentData = useMemo(() => {
    return getempTaskAssignmentQuery.data || [];
  }, [getempTaskAssignmentQuery.data]);

  if (getempTaskAssignmentQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getempTaskAssignmentQuery.isError) {
    return <div>Error: {getempTaskAssignmentQuery.error.message}</div>;
  }
  const taskAssignment = assignmentData?.employees;

  const addNewProject = (event, id) => {
    event.preventDefault();
    handleShowModal();
  };

  const projectColumns = [
    {
      header: "Name",
      accessor: "first_name",
      accessorKey: "first_name",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 text-secondary small">
            {row.row.original.first_name} {row.row.original.father_name}
          </p>
        </div>
      ),
    },

    {
      header: "Total Task",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 small">{row.row.original.tasks.length}</p>
        </div>
      ),
    },

    {
      header: "Task Names",
      cell: (row) => {
        const tasks = row.row.original.tasks;

        return (
          <div className="data-content">
            {tasks.length === 0 ? (
              <p className="m-0  small">No tasks</p>
            ) : (
              tasks.map((task, index) => (
                <p key={index} className="m-0  small">
                  • {task.task_name}
                </p>
              ))
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <BasicTable
        data={taskAssignment}
        columns={projectColumns}
        title={`task_assignment_list`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => addNewProject(e, "id")}
          >
            {t("add_new_assignment")}
          </Button>
        }
      />
      <CustomModal
        show={showModal}
        title="new_task_assignment"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <EmpTaskAssignmentForm
            onSubmitButton={handleButtonSubmit}
            parentID={"id"}
          />
        }
      />
    </div>
  );
};
export default TaskAssignment;
